import moment from 'moment';

const shortMonth = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Ags', 'Sep', 'Okt', 'Nov', 'Des'];
const fullMonth = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'Septempber', 'Oktober', 'November', 'Desember'];
const fullDay = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];

const dateFormatFull = (date = '') => {
    let d = new Date()

    if (date !== '') {
        d = new Date(date)
    }

    let month = '' + d.getMonth(),
        day = '' + d.getDate(),
        year = d.getFullYear();

    return [day, fullMonth[month], year].join(' ');
}

const dateFormatSort = (date = '') => {
    let d = new Date()

    if (date !== '') {
        d = new Date(date)
    }

    let month = '' + (d.getMonth()),
        day = '' + d.getDate(),
        year = d.getFullYear();

    return [day, shortMonth[month], year].join('/');
}

const dateTimeFormat = (date = '') => {
    let d = new Date()

    if (date !== '') {
        d = new Date(date)
    }

    let month = '' + d.getMonth(),
        day = '' + d.getDate(),
        year = d.getFullYear(),
        dayNumber = d.getDay();

    return `${fullDay[dayNumber]}, ${[day, fullMonth[month], year].join(' ')}`;
}

const timeFormat = (date = '') => {
    let d = new Date()

    if (date !== '') {
        d = new Date(date)
    }
    
    return moment(d).format('HH:mm:ss')
}

export {dateFormatFull, dateFormatSort, dateTimeFormat, timeFormat}